import { mergeRight, without, append, uniq } from 'ramda'

const defaultState = {
  members: [],
  selectedMembers: [],
  segment: {}
}

const segmentMembers = (state = defaultState, action) => {
  switch (action.type) {
    case 'RECEIVE_SEGMENT_MEMBERS':
      return mergeRight(state, {
        members: action.segmentMembers
      })

    case 'RECEIVE_SEGMENT_DETAILS':
      return mergeRight(state, {
        segment: action.segmentDetails
      })

    case 'SELECT_SEGMENT_MEMBER':
      if (Array.isArray(action.selectedId)) {
        return mergeRight(state, {
          selectedMembers: uniq(action.selectedId)
        })
      } else {
        return mergeRight(state, {
          selectedMembers: uniq(append(action.selectedId, state.selectedMembers))
        })
      }

    case 'DESELECT_SEGMENT_MEMBER':
      const removed = Array.isArray(action.deselectedId) ? action.deselectedId : [action.deselectedId]

      return mergeRight(state, {
        selectedMembers: without(removed, state.selectedMembers)
      })

    default:
      return state
  }
}

export default segmentMembers